/**
 * Branch Indicator Component
 * Menampilkan cabang aktif untuk admin/kasir (fixed indicator)
 * Owner tidak perlu indicator karena bisa switch branch
 */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { getBranches } from '../../services/branchService';

interface Branch {
  id: number;
  code: string;
  name: string;
  address: string;
}

const BranchIndicator: React.FC = () => {
  const currentUser = useSelector((state: RootState) => state.auth.user);
  const [userBranch, setUserBranch] = useState<Branch | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBranchInfo = async () => {
      if (!currentUser?.branch_id) {
        setLoading(false);
        return;
      }

      try {
        const branches = await getBranches();
        const branch = branches.find(b => b.id === currentUser.branch_id);
        setUserBranch(branch || null);
      } catch (error) {
        console.error('Failed to load branch info:', error);
      } finally {
        setLoading(false);
      }
    };

    loadBranchInfo();
  }, [currentUser?.branch_id]);

  // Jangan tampilkan untuk owner (owner bisa switch branch)
  if (!currentUser || currentUser.role === 'owner') {
    return null;
  }

  // Jangan tampilkan jika loading atau tidak ada branch
  if (loading || !userBranch) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 z-40 bg-gradient-to-r from-blue-600 to-blue-700 text-white px-4 py-3 rounded-lg shadow-lg animate-fadeIn">
      <div className="flex items-center gap-3">
        <div className="bg-white/20 p-2 rounded-lg">
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
            />
          </svg>
        </div>
        <div>
          <div className="text-xs opacity-90 font-medium">Cabang Aktif</div>
          <div className="font-bold text-sm">
            {userBranch.code} - {userBranch.name}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BranchIndicator;
